import { render, staticRenderFns } from "./Projektstunden.vue?vue&type=template&id=7568932c&scoped=true"
import script from "./Projektstunden.vue?vue&type=script&lang=ts"
export * from "./Projektstunden.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7568932c",
  null
  
)

export default component.exports